import React from 'react';
import TabManager from './TabManager';

const TabManagerRoute = () => {
  return <TabManager />;
};

export default TabManagerRoute;
